(function () {
  'use strict';
  function initNavigation() {
    var toggle = document.querySelector('.site-nav__toggle');
    var menu = document.getElementById('site-nav-menu');
    var nav = document.querySelector('.site-nav');
    if (!toggle || !menu) return;
    function closeMenu() {
      toggle.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
      document.body.classList.remove('nav-is-open');
      menu.querySelectorAll('.is-submenu-open').forEach(function (item) {
        item.classList.remove('is-submenu-open');
        var button = item.querySelector(':scope > .scp-submenu-toggle');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
      document.body.classList.toggle('nav-is-open', !open);
    });
    menu.addEventListener('click', function (event) {
      var button = event.target.closest('.scp-submenu-toggle');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      var item = button.closest('.menu-item-has-children');
      if (!item) return;
      var expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      item.classList.toggle('is-submenu-open', !expanded);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 900) closeMenu();
    }, { passive: true });
    initSearchToggle();
  }
  function initSearchToggle() {
    var button = document.querySelector('.site-nav__search');
    var panel = document.getElementById('site-nav-search');
    var input = document.getElementById('site-nav-search-input');
    if (!button || !panel) return;
    function closeSearch() {
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Open search');
      panel.hidden = true;
      panel.classList.remove('is-open');
    }
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var open = button.getAttribute('aria-expanded') === 'true';
      if (open) { closeSearch(); return; }
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', 'Close search');
      panel.hidden = false;
      panel.classList.add('is-open');
      window.setTimeout(function () { if (input) input.focus(); }, 0);
    });
    document.addEventListener('click', function (event) {
      var wrap = button.closest('.site-nav__search-wrap');
      if (!panel.hidden && wrap && !wrap.contains(event.target)) closeSearch();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) { closeSearch(); button.focus(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initNavigation);
  else initNavigation();
})();
